import { library } from '@fortawesome/fontawesome-svg-core';
import { faFacebook as faFacebookBrands, faLinkedin as faLinkedinBrands, faTwitter as faTwitterBrands } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope as faEnvelopeRegular, faSignIn as faSignInRegular, faSignOut as faSignOutRegular } from '@fortawesome/pro-regular-svg-icons';
library.add(faFacebookBrands, faLinkedinBrands, faTwitterBrands, faEnvelopeRegular, faSignInRegular, faSignOutRegular);
